import { HttpRequest } from './HttpRequest'
import { PublicClientApplication, InteractionRequiredAuthError, PopupRequest, AccountInfo, AuthenticationResult } from '@azure/msal-browser'
import { config } from "@/config"
import { AuthenticateApi } from "@/api"

export const msalInstance = new PublicClientApplication({
    auth: {
        clientId: config.azureAd.clientId,
        authority: config.azureAd.authority
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    },
})

export const LoginAD = async () => {
    try {
        const loginRequest: PopupRequest = {
            scopes: config.azureAd.scopes
        }
        const loginResponse: AuthenticationResult = await msalInstance.loginPopup(loginRequest);
        console.log("loginResponse : ", loginResponse);
        //const getUserInfo = await AuthenticateApi.GetUserInfo();
        //console.log("get User Infor : ", getUserInfo);

        if(loginResponse.account?.name != "") {
            localStorage.setItem('isAuth', 'authorized')
        } else {
            localStorage.setItem('isAuth', 'unauthorized')
        }

    } catch (err: any) {
        throw new Error
    }
}

export const LogOutAd = async () => {
    await msalInstance.logoutPopup();
    localStorage.removeItem('isAuth')
}

export const GetAcquireToken = async () => {
    const request = {
        account: msalInstance.getAllAccounts()[0],
        scopes: config.azureAd.scopes,
        forceRefresh: false
    }
    try {
		const response = await msalInstance.acquireTokenSilent(request);
        localStorage.setItem('token', response.accessToken)
		return response.accessToken;            
	} catch (error) {
		if (error instanceof InteractionRequiredAuthError) {
			return msalInstance.acquireTokenPopup(request).catch((popupError) => {
				console.error(popupError);
			});
		}
		return false;
	}
}

export const GetAcquireTokenRead = async () => {
    const request = {
        account: msalInstance.getAllAccounts()[0],
        scopes: ["User.Read"],
        forceRefresh: false
    }
    try {
		const response = await msalInstance.acquireTokenSilent(request);
        localStorage.setItem('TOKEN_GRAPHMICROSOFT', response.accessToken)
		return response.accessToken;            
	} catch (error) {
		if (error instanceof InteractionRequiredAuthError) {
			return msalInstance.acquireTokenPopup(request).catch((popupError) => {
				console.error(popupError);
			});
		}
		return false;
	}
}

export const GetIsAuthenticated = async () => {
    try {
        const accounts: AccountInfo[] = msalInstance.getAllAccounts()
        await GetUserInfo();
        return accounts && accounts.length > 0
    } catch (error) {
        return false
    }
    
}

export const GetUserInfo = async () => {
    try { 
        const response = await HttpRequest().get(`/users/info`)
        if (response.data.message === 'OK') {
            const result: IGetUserInfo = response.data.responseData
            return result
        }
        return null
    } catch (error: any) {
        throw error
    }
}

export const Login = async (login: { email: string, password: string }) => {
    let data = JSON.stringify(login);
    try {
        const response = await HttpRequest().post(`/users/authenticate`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'success') {
            return response.data.responseData[0]
        }
    } catch (error: any) {
        if (error.response.status === 401) return error.response.data.message
        throw new Error('error api /users/authenticate')
    }
}

export interface IGetUserInfo {
    email: string
    firstName: string
    lastName: string
    userId: number
    userCode: string
    userFlag: boolean
    userRoleId: number
    userRoleCode: string
    userDeptId: number
    userDeptCode: string
    userAllProjectFlag: boolean
    permission: IPermission[]
  }

  export interface IPermission {
    profileCode: string
    profileDescription: string
}